module.exports = __webpack_public_path__ + "static/media/dice_3.1c5ac47f.svg";